import { tailwindTokenToHex } from './utils'

/** Inline color field with Tailwind class input + swatch */
export function InlineColorField({
  label,
  value,
  onChange,
  testId,
}: {
  label: string
  value: string
  onChange: (value: string) => void
  testId?: string
}) {
  // Convert Tailwind color token to a rough CSS color for swatch preview
  const swatchColor = tailwindTokenToHex(value)

  return (
    <div className="flex justify-between items-center gap-2">
      <span className="text-muted-foreground text-xs shrink-0">{label}</span>
      <div className="flex items-center gap-1.5">
        <div
          className="h-6 w-6 rounded border border-input shrink-0"
          style={{ backgroundColor: swatchColor }}
          title={swatchColor}
        />
        <input
          type="text"
          className="w-24 h-6 text-xs border border-input rounded bg-background px-1.5 focus:outline-none focus:ring-1 focus:ring-ring"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="e.g. blue-500"
          data-testid={testId ?? `color-${label.toLowerCase().replace(/\s+/g, '-')}`}
        />
      </div>
    </div>
  )
}
